// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__3k-oK","cp-modal-details-body":"styles_cp-modal-details-body__7ZzDK"};